import { Formik, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { productRestrictionCreateAction } from "../../redux/actions/product-action";
import AddButton from "../buttons/button";
import CheckBox from "../forms/check-box-field";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";

const RestrictionsTab = ({
  productId,
  uomList,
  setFormValues,
  formValues,
  setCurrentTab,
  product,
  disabled = false,
  itemGeneralData = {},
  onTabChange,
}) => {
  const dispatch = useDispatch();

  // Restrictions tab specific state for navigation blocking
  const [restrictionsHasUnsavedChanges, setRestrictionsHasUnsavedChanges] =
    useState(false);
  const [restrictionsIsFormSaved, setRestrictionsIsFormSaved] = useState(false);
  const initialValues = {
    item_id: product?.item_id ?? productId,
    item_sales_invoice: product?.item_sales_invoice ?? false,
    item_sales_returns: product?.item_sales_returns ?? false,
    item_purchase_request: product?.item_purchase_request ?? false,
    item_discontiue: product?.item_discontiue ?? false,
    item_purchasing_order: product?.item_purchasing_order ?? false,
    item_credit_note: product?.item_credit_note ?? false,
    item_debit_note: product?.item_debit_note ?? false,
    item_stock_in: product?.item_stock_in ?? false,
    item_stock_out: product?.item_stock_out ?? false,
    item_purchase_return: product?.item_purchase_return ?? false,
    item_purchase_invoice: product?.item_purchase_invoice ?? false,
    item_purchase_credit_note: product?.item_purchase_credit_note ?? false,
    item_grn: product?.item_grn ?? false,
    item_payment_out: product?.item_payment_out ?? false,
    item_sales_order: product?.item_sales_order ?? false,
    item_sales_delivery_note: product?.item_sales_delivery_note ?? false,
    item_sales_credit_note: product?.item_sales_credit_note ?? false,
    item_payment_in: product?.item_payment_in ?? false,
    item_return_bill: product?.item_return_bill ?? false,
    item_bill: product?.item_bill ?? false,
    item_stock_transfer: product?.item_stock_transfer ?? false,
  };
  const validationSchema = Yup.object().shape({});

  // Restrictions tab change tracker and navigation blocking
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      // Don't track changes if form was just saved
      if (restrictionsIsFormSaved) {
        setRestrictionsHasUnsavedChanges(false);
        if (onTabChange) {
          onTabChange(false);
        }
        return;
      }

      // Compare with initial values
      const hasChanges =
        JSON.stringify(initialValues) !== JSON.stringify(values);
      setRestrictionsHasUnsavedChanges(hasChanges);

      // Notify parent component about changes
      if (onTabChange) {
        onTabChange(hasChanges);
      }

      console.log("=== RESTRICTIONS TAB CHANGE TRACKER ===");
      console.log("Restrictions has changes:", hasChanges);
      console.log("Initial values:", initialValues);
      console.log("Current values:", values);
    }, [values, restrictionsIsFormSaved, onTabChange]);

    // Navigation blocking is now handled by parent component (EditProduct)

    return null;
  };

  const innerOnSubmit = (values) => {
    if (JSON.stringify(initialValues) === JSON.stringify(values)) {
      return errorToast("No changes");
    }
    setFormValues({
      ...formValues,
      restrictions: values,
    });

    // Reset restrictions form state after successful submission
    setRestrictionsHasUnsavedChanges(false);
    setRestrictionsIsFormSaved(true);
    dispatch(
      productRestrictionCreateAction(
        {
          itemGeneralData: itemGeneralData,
          itemRestrictionData: values,
        },
        onSuccess,
        onError
      )
    );
  };

  const onSuccess = (data) => {
    successToast(data?.message);
    setCurrentTab("Remarks");
  };
  const onError = (data) => {};

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={formValues?.restrictions ?? initialValues}
        validationSchema={validationSchema}
        onSubmit={innerOnSubmit}
      >
        {({ handleSubmit }) => {
          return (
            <>
              <FormChangeTracker />
              <div className="w-full xl:w-[80%] px-5 xl:px-10 mt-0 pt-0">
                <CheckBox
                  isDisabled={disabled}
                  height="4rem"
                  width="10rem"
                  conClass="flex justify-between flex-wrap "
                  items={restrictionsOptions}
                />
                <CheckBox
                  isDisabled={disabled}
                  height="4rem"
                  width="10rem"
                  conClass="flex justify-between flex-wrap"
                  items={restrictions2Options}
                />
                <CheckBox
                  isDisabled={disabled}
                  height="4rem"
                  width="10rem"
                  conClass="flex justify-between flex-wrap"
                  items={restrictions3Options}
                />
                <CheckBox
                  isDisabled={disabled}
                  height="4rem"
                  width="10rem"
                  conClass="flex justify-between flex-wrap"
                  items={restrictions4Options}
                />
              </div>
              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={handleSubmit}
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                  />
                </div>
              )}
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default RestrictionsTab;

export const serialBatchesOptns = [
  { label: "Item Group", value: "item_group" },
];
const restrictionsOptions = [
  {
    label: "Sales Invoice",
    name: "item_sales_invoice",
    isRequired: false,
  },
  {
    label: "Sales Returns",
    name: "item_sales_returns",
    isRequired: false,
  },
  {
    label: "Purchase Request",
    name: "item_purchase_request",
    isRequired: false,
  },
  {
    label: "Purchase Return",
    name: "item_purchase_return",
    isRequired: false,
  },
  {
    label: "Discontinue",
    name: "item_discontiue",
    isRequired: false,
  },
];
const restrictions2Options = [
  {
    label: "Purchasing Order",
    name: "item_purchasing_order",
    isRequired: false,
  },
  {
    label: "Credit Note",
    name: "item_credit_note",
    isRequired: false,
  },
  {
    label: "Debit Note",
    name: "item_debit_note",
    isRequired: false,
  },
  {
    label: "Stock In",
    name: "item_stock_in",
    isRequired: false,
  },
  {
    label: "Stock Out",
    name: "item_stock_out",
    isRequired: false,
  },
];
const restrictions3Options = [
  {
    name: "item_stock_transfer",
    label: "Stock Transfer",
    isRequired: false,
  },
  {
    label: "Return Bill",
    name: "item_return_bill",
    isRequired: false,
  },
  {
    label: "Bill",
    name: "item_bill",
    isRequired: false,
  },

  {
    label: "Purchase Invoice",
    name: "item_purchase_invoice",
    isRequired: false,
  },
  {
    label: "Purchase Credit Note",
    name: "item_purchase_credit_note",
    isRequired: false,
  },
];
const restrictions4Options = [
  {
    label: "GRN",
    name: "item_grn",
    isRequired: false,
  },
  {
    label: "Payment Out",
    name: "item_payment_out",
    isRequired: false,
  },
  {
    label: "Sales Order",
    name: "item_sales_order",
    isRequired: false,
  },
  {
    label: "Sales Delivery Note",
    name: "item_sales_delivery_note",
    isRequired: false,
  },
  {
    label: "Sales Credit Note",
    name: "item_sales_credit_note",
    isRequired: false,
  },
  {
    label: "Payment In",
    name: "item_payment_in",
    isRequired: false,
  },
];
